import React from "react";
import { Box, Heading, HStack, Icon, Text } from "@chakra-ui/react";

export default function CountIconBox({ icon, number, title }) {
  return (
    <HStack
      rounded="2xl"
      bgColor="white"
      shadow="md"
      py="4"
      px="4"
      gap={3}
      w="230px"
    >
      <Box
        bgColor="primary.100"
        rounded="full"
        w="fit-content"
        px="4"
        pt="4"
        pb="2"
      >
        <Icon as={icon} color="primary.main" fontSize="3xl" />
      </Box>
      <Box>
        <Heading fontSize="3xl">
          {new Intl.NumberFormat("en-US", { notation: "compact" }).format(
            number
          )}
        </Heading>
        <Text color="primary.main" fontSize="sm">
          {title}
        </Text>
      </Box>
    </HStack>
  );
}
